import React from "react";
import PermissionScope from "./PermissionScope/PermissionScope";
import { PermissionAction } from "../../../../interfaces";
import { useRolePermissionsContext } from "../../../../context/RolePermissionsContext";
import { TooltipCustom } from "@services/ui-components";

type PermissionChildActionRowProps = {
    currentChild: PermissionAction;
    className?: string;
    moduleCode: string;
};

const PermissionChildActionRow: React.FC<PermissionChildActionRowProps> = ({
    className = "",
    moduleCode,
    currentChild,
}) => {
    const childId = `${currentChild.code}-${currentChild.order}`;
    const { label, supportsScope, scope, code, isActive } = currentChild;

    const { onChangePermissionAction, mode } = useRolePermissionsContext();
    const isViewMode = mode === "view";
    const showScope = (isViewMode && supportsScope && isActive && scope) || (!isViewMode && supportsScope && scope);

    return (
        <div className={`mt-3 ms-4 ps-4 ${className}`}>
            <div className="d-flex align-items-start">
                <div className={`${!isViewMode ? "form-check" : ""} mb-0 d-flex align-items-start`}>
                    {isViewMode ? (
                        <>
                            {isActive ? (
                                <i className="bi bi-check-circle-fill text-primary me-2"></i>
                            ) : (
                                <i className="bi bi-x-circle-fill text-orange me-2"></i>
                            )}

                            <p className="form-check-label mb-0 fw-bold">
                                {label}
                                {currentChild.descriptionInfo && (
                                    <TooltipCustom placement="right" text={currentChild.descriptionInfo}>
                                        <i className="bi bi-info-circle fs-normal ms-2 i-to-block"></i>
                                    </TooltipCustom>
                                )}
                            </p>
                        </>
                    ) : (
                        <>
                            <input
                                id={childId}
                                type="checkbox"
                                className="form-check-input me-2"
                                checked={isActive}
                                onChange={(e) => onChangePermissionAction(moduleCode, code, e.target.checked)}
                            />

                            <label htmlFor={childId} className="form-check-label mb-0 text-dark">
                                {label}
                                {currentChild.descriptionInfo && (
                                    <TooltipCustom placement="right" text={currentChild.descriptionInfo}>
                                        <i className="bi bi-info-circle fs-normal ms-2 i-to-block"></i>
                                    </TooltipCustom>
                                )}
                            </label>
                        </>
                    )}
                </div>
            </div>

            {showScope && (
                <PermissionScope moduleCode={moduleCode} actionCode={code} scope={scope} isChildActive={isActive} />
            )}
        </div>
    );
};

export default React.memo(PermissionChildActionRow);
